import React from "react";

const TemplateBanner = ({
  icon,
  title,
  subtitle,
  gradientStart = "#00afe4",
  gradientEnd = "#5bc500",
  action,
}) => {
  return (
    <div
      className="banner-templates"
      style={{
        backgroundImage: `url(/img/banner-wave.png), linear-gradient(90deg, ${gradientStart}, ${gradientEnd})`,
        backgroundPosition: "right, 0 0",
        backgroundRepeat: "no-repeat, repeat",
      }}
    >
      <div
        className="banner-templates-content"
        style={{
          backgroundImage: `url(/img/banner-wave.png)`,
        }}
      >
        {icon && (
          <span className="banner-templates-icon">
            <img src={icon} alt="" aria-hidden />
          </span>
        )}
        <div className="banner-templates-text">
          <span className="banner-templates-title">{title}</span>
          <span className="banner-templates-subtitle">{subtitle}</span>
        </div>
        {action && <div className="banner-templates-action">{action}</div>}
      </div>
    </div>
  );
};

export default TemplateBanner;
